import { render, staticRenderFns } from "./DatabaseBackup.vue?vue&type=template&id=3e7c3fa1"
import script from "./DatabaseBackup.vue?vue&type=script&lang=js"
export * from "./DatabaseBackup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports